import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
import replace from "./replace";
export var reLaunch = normalize.reLaunch(function (options) {
  var url = options.url,
    _options$isHash = options.isHash,
    isHash = _options$isHash === void 0 ? false : _options$isHash,
    _options$refresh = options.refresh,
    refresh = _options$refresh === void 0 ? true : _options$refresh,
    success = options.success,
    fail = options.fail,
    complete = options.complete;
  var _url = isHash ? "/#" + url : url;
  setTimeout(function () {
    try {
      // eslint-disable-next-line @iceworks/best-practices/no-http-url
      if ((url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) && url.indexOf(location.origin) === -1) {
        console.warn('Uni API: Relaunch does not support cross-domain');
        location.href = url;
        return;
      }
      history.go(-(history.length - 1));
      if (isHash) {
        replace({
          url: url,
          isHash: true
        });
      } else {
        window.history.replaceState(null, null, _url);
        refresh && location.reload();
      }
      success && success();
      complete && complete();
    } catch (e) {
      fail && fail(e);
      complete && complete(e);
    }
  });
}, CONTAINER_NAME.WEB);
export default reLaunch;